<template>
  <div class="add-installation-view">
    <!-- Nagłówek -->
    <div class="page-header">
      <div class="header-content">
        <h3 class="page-title">Dodaj nową instalację</h3>
        <p class="page-subtitle">Wypełnij formularz aby dodać nową instalację do systemu</p>
      </div>
      <router-link to="/eventlist">
        <button class="btn-back">
          ← Powrót do listy
        </button>
      </router-link>
    </div>

    <!-- Formularz -->
    <div class="form-container">
      <form @submit.prevent="addInstallation">        
        <!-- Sekcja kontrahenta -->
        <div class="form-section">
          <h5 class="section-title">
            <span class="section-icon">👤</span>
            Kontrahent
          </h5>
          
          <div class="form-group">
            <label class="form-label">Wybierz kontrahenta *</label>
            <v-select
              v-model="contractor"
              label="label"
              :options="contractors"
              placeholder="Zacznij wpisywać aby wyszukać..."
              class="custom-v-select"
            ></v-select>
            <div v-if="!contractor && formTouched" class="error-message">
              Wybór kontrahenta jest wymagany
            </div>
          </div>
        </div>

        <!-- Sekcja szczegółów instalacji -->
        <div class="form-section">
          <h5 class="section-title">
            <span class="section-icon">🔧</span>
            Szczegóły instalacji
          </h5>

          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Numer seryjny urządzenia</label>
              <input
                v-model="serialNumber"
                type="text"
                class="form-input"
                placeholder="np. SN-2026-001"
              />
            </div>

            <div class="form-group">
              <label class="form-label">Brygada montażowa</label>
              <v-select
                v-model="squad"
                :options="['Brygada 1', 'Brygada 2', 'Brygada 3']"
                placeholder="Wybierz brygadę"
                class="custom-v-select"
              ></v-select>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label class="form-label">Data montażu *</label>
              <input
                v-model="date"
                type="date"
                class="form-input"
              />
            </div>

            <div class="form-group">
              <label class="form-label">Data przeglądu (wykonany)</label>
              <input
                v-model="service"
                type="date"
                class="form-input"
                @change="updatePlannedService"
              />
            </div>

            <div class="form-group">
              <label class="form-label">Data planowanego serwisu</label>
              <input
                v-model="plannedService"
                type="date"
                class="form-input"
              />
            </div>
          </div>

          <div class="form-group">
            <label class="form-checkbox-wrapper">
              <input
                v-model="underWarranty"
                type="checkbox"
                class="form-checkbox"
              />
              <span class="checkbox-label">
                <span class="checkbox-icon">🛡️</span>
                Urządzenie jest na gwarancji
              </span>
            </label>
          </div>

          <div class="form-group">
            <label class="form-label">Uwagi</label>
            <vue-editor v-model="notice" class="editor"></vue-editor>
          </div>
        </div>

        <!-- Sticky footer z przyciskiem -->
        <div class="form-footer">
          <button
            type="submit"
            class="btn-submit"
            :disabled="!contractor || !date"
          >
            <span class="submit-icon">✓</span>
            Dodaj instalację
          </button>
          <router-link to="/eventlist" class="btn-cancel">
            Anuluj
          </router-link>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import router from "../router/index";
import { mapState } from "vuex";
import { VueEditor } from "vue2-editor";
export default {
  data() {
    return {
      contractor: "",
      serialNumber: "",
      amountOfRefrigerant: "",
      notice: "",
      date: "",
      overview: "",
      service: "",
      plannedService: "",
      underWarranty: false,
      squad: "",
      formTouched: false,
    };
  },
  computed: {
    ...mapState(["userProfile", "contractors"]),
  },
  components: {
    VueEditor,
  },
  mounted() {
    // Pobierz kontrahentów jeśli nie są jeszcze załadowani
    if (!this.contractors || this.contractors.length === 0) {
      const limits = this.$store.state.userProfile.limits;
      const limit = (limits && limits.contractors) || 1000;
      this.$store.dispatch("getContractors", { limit });
    }
  },
  methods: {
    updatePlannedService() {
      if (this.service) {
        const serviceDate = new Date(this.service);
        serviceDate.setFullYear(serviceDate.getFullYear() + 1);
        const year = serviceDate.getFullYear();
        const month = String(serviceDate.getMonth() + 1).padStart(2, '0');
        const day = String(serviceDate.getDate()).padStart(2, '0');
        this.plannedService = `${year}-${month}-${day}`;
      }
    },
    addInstallation() {
      this.formTouched = true;
      
      // Walidacja wymaganych pól
      if (!this.contractor) {
        return;
      }
      if (!this.date) {
        return;
      }

      this.$store
        .dispatch("createInstallation", {
          contractor: this.contractor,
          serialNumber: this.serialNumber,
          date: this.date,
          notice: this.notice,
          overview: this.overview,
          service: this.service,
          plannedService: this.plannedService,
          underWarranty: this.underWarranty,
          squad: this.squad,
        })
        .then(() => {
          this.contractor = "";
          this.serialNumber = "";
          this.amountOfRefrigerant = "";
          this.notice = "";
          this.date = "";
          this.overview = "";
          this.service = "";
          this.plannedService = "";
          this.underWarranty = false;
          this.squad = "";
          this.formTouched = false;
          
          // Toast notification instead of alert
          this.showSuccessToast();
          
          setTimeout(() => {
            router.push("/eventlist");
          }, 1000);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    
    showSuccessToast() {
      // Simple success message
      const toast = document.createElement('div');
      toast.className = 'success-toast';
      toast.textContent = '✓ Instalacja została dodana';
      document.body.appendChild(toast);
      
      setTimeout(() => {
        toast.classList.add('show');
      }, 100);
      
      setTimeout(() => {
        toast.classList.remove('show');
        setTimeout(() => toast.remove(), 300);
      }, 3000);
    },
  },
};
</script>

<style scoped>
.add-installation-view {
  padding: 20px;
  background: #f8f9fa;
  min-height: 100vh;
}

/* HEADER */
.page-header {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  padding: 32px;
  margin-bottom: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.header-content {
  flex: 1;
}

.page-title {
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0 0 8px 0;
}

.page-subtitle {
  color: #6c757d;
  font-size: 14px;
  margin: 0;
}

.btn-back {
  padding: 12px 24px;
  background: white;
  color: #667eea;
  border: 2px solid #667eea;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
}

.btn-back:hover {
  background: #667eea;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

/* FORMULARZ */
.form-container {
  max-width: 900px;
  margin: 0 auto;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  overflow: hidden;
}

form {
  padding: 32px;
  padding-bottom: 100px;
}

.form-section {
  margin-bottom: 32px;
  padding-bottom: 32px;
  border-bottom: 2px solid #f0f0f0;
}

.form-section:last-of-type {
  border-bottom: none;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-icon {
  font-size: 20px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-label {
  font-size: 14px;
  font-weight: 600;
  color: #4a5568;
  margin-bottom: 8px;
}

.form-input {
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  transition: all 0.3s ease;
}

.form-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-input::placeholder {
  color: #a0aec0;
}

/* --- Checkbox --- */
.form-checkbox-wrapper {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  transition: all 0.3s ease;
  background: #f8f9fa;
}

.form-checkbox-wrapper:hover {
  background: #e8edf5;
  border-color: #667eea;
}

.form-checkbox {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-right: 12px;
  accent-color: #667eea;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 500;
  color: #2c3e50;
  user-select: none;
}

.checkbox-icon {
  font-size: 18px;
}

/* V-SELECT CUSTOM */
.custom-v-select {
  width: 100%;
}

.custom-v-select :deep(.vs__dropdown-toggle) {
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 12px;
  transition: all 0.3s ease;
}

.custom-v-select :deep(.vs__dropdown-toggle:hover) {
  border-color: #cbd5e0;
}

.custom-v-select :deep(.vs--open .vs__dropdown-toggle) {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.custom-v-select :deep(.vs__selected) {
  color: #2c3e50;
  font-size: 15px;
}

.custom-v-select :deep(.vs__search::placeholder) {
  color: #a0aec0;
}

.custom-v-select :deep(.vs__dropdown-menu) {
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-top: 4px;
}

.custom-v-select :deep(.vs__dropdown-option) {
  padding: 12px 16px;
  transition: all 0.2s ease;
}

.custom-v-select :deep(.vs__dropdown-option--highlight) {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

/* EDITOR */
.editor :deep(.quillWrapper) {
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.editor :deep(.quillWrapper:focus-within) {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.editor :deep(.ql-toolbar) {
  background: #f8f9fa;
  border: none;
  border-bottom: 2px solid #e2e8f0;
}

.editor :deep(.ql-container) {
  border: none;
  min-height: 150px;
  font-size: 15px;
}

/* MESSAGES */
.error-message {
  margin-top: 8px;
  color: #e53e3e;
  font-size: 13px;
  font-weight: 500;
}

.warning-message {
  margin-top: 8px;
  color: #dd6b20;
  font-size: 13px;
  font-weight: 500;
}

/* FOOTER */
.form-footer {
  position: sticky;
  bottom: 0;
  background: white;
  border-top: 2px solid #f0f0f0;
  padding: 20px 32px;
  display: flex;
  gap: 12px;
  justify-content: center;
  align-items: center;
  box-shadow: 0 -4px 12px rgba(0,0,0,0.05);
  margin: 0 -32px -32px;
}

.btn-submit {
  padding: 14px 32px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-submit:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.btn-submit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.submit-icon {
  font-size: 18px;
}

.btn-cancel {
  padding: 12px 24px;
  background: white;
  color: #718096;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
}

.btn-cancel:hover {
  background: #f8f9fa;
  border-color: #cbd5e0;
  color: #4a5568;
}

/* SUCCESS TOAST */
.success-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
  color: white;
  padding: 16px 24px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(17, 153, 142, 0.3);
  font-weight: 500;
  opacity: 0;
  transform: translateX(400px);
  transition: all 0.3s ease;
  z-index: 9999;
}

.success-toast.show {
  opacity: 1;
  transform: translateX(0);
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .add-installation-view {
    padding: 12px;
  }

  .page-header {
    padding: 20px;
    flex-direction: column;
    align-items: flex-start;
  }

  .page-title {
    font-size: 24px;
  }

  .btn-back {
    width: 100%;
    text-align: center;
  }

  form {
    padding: 20px;
    padding-bottom: 80px;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .form-footer {
    padding: 16px 20px;
    flex-direction: column;
    margin: 0 -20px -20px;
  }

  .btn-submit,
  .btn-cancel {
    width: 100%;
    justify-content: center;
  }
}
</style>
